import {AuthenticationResult} from './global';
import {LogoutOptions} from "@auth0/auth0-spa-js/src/global.ts";

export const parseAuthenticationResult = (
    queryString: string
): AuthenticationResult => {
    if (queryString.indexOf('#') > -1) {
        queryString = queryString.substring(0, queryString.indexOf('#'));
    }

    const searchParams = new URLSearchParams(queryString);

    return {
        state: searchParams.get('state')!,
        code: searchParams.get('code') || undefined,
        verifier: searchParams.get('verifier') || '',
        redirect_uri: searchParams.get('redirect_uri') || '',
        error: searchParams.get('error') || undefined,
        error_description: searchParams.get('error_description') || undefined
    };
};


export const getCrypto = () => {
    return window.crypto;
};

const stripUndefined = (params: any) => {
    return Object.keys(params)
        .filter(k => typeof params[k] !== 'undefined')
        .reduce((acc, key) => ({...acc, [key]: params[key]}), {});
};

export const createQueryParams = ({clientId: client_id, ...params}: any) => {
    return new URLSearchParams(
        stripUndefined({client_id, ...params})
    ).toString();
};

// https://stackoverflow.com/questions/30106476/
const decodeB64 = (input: string) =>
    decodeURIComponent(
        atob(input)
            .split('')
            .map(c => {
                return '%' + ('00' + c.charCodeAt(0).toString(16)).slice(-2);
            })
            .join('')
    );

export const urlDecodeB64 = (input: string) =>
    decodeB64(input.replace(/_/g, '/').replace(/-/g, '+'));

export const validateCrypto = () => {
    if (!getCrypto()) {
        throw new Error(
            'For security reasons, `window.crypto` is required to run `auth0-spa-js`.'
        );
    }
    if (typeof getCrypto().subtle === 'undefined') {
        throw new Error(`
      auth0-spa-js must run on a secure origin. See https://github.com/auth0/auth0-spa-js/blob/main/FAQ.md#why-do-i-get-auth0-spa-js-must-run-on-a-secure-origin for more information.
    `);
    }
};

/**
 * @ignore
 */
export const getDomain = (domainUrl: string) => {
    if (!/^https?:\/\//.test(domainUrl)) {
        return `https://${domainUrl}`;
    }

    return domainUrl;
};

/**
 * @ignore
 */
export const getTokenIssuer = (
    issuer: string | undefined,
    domainUrl: string
) => {
    if (issuer) {
        return issuer.startsWith('https://') ? issuer : `https://${issuer}/`;
    }

    return `${domainUrl}/`;
};

export const parseNumber = (value: any): number | undefined => {
    if (typeof value !== 'string') {
        return value;
    }
    return parseInt(value, 10) || undefined;
};

export const  patchOpenUrlWithOnRedirect = <
    T extends Pick<LogoutOptions, 'openUrl' | 'onRedirect'>
>(
    options: T
) => {
    const { openUrl, onRedirect, ...originalOptions } = options;

    const result = {
        ...originalOptions,
        openUrl: openUrl === false || openUrl ? openUrl : onRedirect
    };

    return result as T;
};
